import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('ขอบคุณสำหรับการติดต่อ เราจะติดต่อกลับในเร็วๆ นี้');
  };

  const services = [
    'Security Solutions',
    'Energy Solutions',
    'Network & Internet',
    'Software & Application',
    'IPTV & Digital Signage',
    'อื่นๆ'
  ];

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-napa-blue-800 mb-4">
            ติดต่อเรา
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            พร้อมให้คำปรึกษาและออกแบบโซลูชันที่เหมาะสมกับความต้องการของคุณ
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold text-napa-blue-800 mb-6">
              ข้อมูลติดต่อ
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-white text-xl">📍</span>
                </div>
                <div>
                  <h4 className="font-semibold text-napa-blue-800 mb-1">ที่อยู่</h4>
                  <p className="text-gray-600">
                    Napa Corporation<br />
                    Solutions & Services<br />
                    กรุงเทพมหานคร, ประเทศไทย
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-white text-xl">📞</span>
                </div>
                <div>
                  <h4 className="font-semibold text-napa-blue-800 mb-1">โทรศัพท์</h4>
                  <p className="text-gray-600">
                    +66 XX-XXX-XXXX<br />
                    +66 XX-XXX-XXXX
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-white text-xl">✉️</span>
                </div>
                <div>
                  <h4 className="font-semibold text-napa-blue-800 mb-1">อีเมล</h4>
                  <p className="text-gray-600">
                    info@napacorporation.com<br />
                    sales@napacorporation.com
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-white text-xl">🕒</span>
                </div>
                <div>
                  <h4 className="font-semibold text-napa-blue-800 mb-1">เวลาทำการ</h4>
                  <p className="text-gray-600">
                    จันทร์ - ศุกร์: 08:00 - 18:00<br />
                    เสาร์: 09:00 - 17:00<br />
                    อาทิตย์: ปิดทำการ
                  </p>
                </div>
              </div>
            </div>

            {/* Service Areas */}
            <div className="mt-8">
              <h4 className="text-lg font-bold text-napa-blue-800 mb-4">
                กลุ่มลูกค้าที่ให้บริการ
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {[
                  'งานราชการ',
                  'โรงแรม / รีสอร์ท',
                  'โรงงาน / โรงพยาบาล',
                  'สถานศึกษา',
                  'ศูนย์กระจายสินค้า',
                  'ร้านอาหาร / Mart',
                  'หมู่บ้านและคอนโด',
                  'งานติดตั้งภายในบ้าน'
                ].map((area, index) => (
                  <div key={index} className="flex items-center text-sm text-gray-600">
                    <svg className="w-4 h-4 text-napa-blue-500 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    {area}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h3 className="text-2xl font-bold text-napa-blue-800 mb-6">
              ส่งข้อความถึงเรา
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    ชื่อ-นามสกุล *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-napa-blue-500 focus:border-napa-blue-500 transition-colors"
                    placeholder="กรุณากรอกชื่อ-นามสกุล"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    เบอร์โทรศัพท์ *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-napa-blue-500 focus:border-napa-blue-500 transition-colors"
                    placeholder="กรุณากรอกเบอร์โทรศัพท์"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    อีเมล *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-napa-blue-500 focus:border-napa-blue-500 transition-colors"
                    placeholder="กรุณากรอกอีเมล"
                  />
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                    บริษัท/องค์กร
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-napa-blue-500 focus:border-napa-blue-500 transition-colors"
                    placeholder="กรุณากรอกชื่อบริษัท/องค์กร"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                  บริการที่สนใจ
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-napa-blue-500 focus:border-napa-blue-500 transition-colors"
                >
                  <option value="">เลือกบริการที่สนใจ</option>
                  {services.map((service, index) => (
                    <option key={index} value={service}>{service}</option>
                  ))}
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  ข้อความ *
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  value={formData.message}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-napa-blue-500 focus:border-napa-blue-500 transition-colors resize-none"
                  placeholder="กรุณาแจ้งรายละเอียดความต้องการหรือคำถาม"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-napa-blue-600 to-napa-blue-800 text-white py-3 px-6 rounded-lg font-semibold hover:from-napa-blue-700 hover:to-napa-blue-900 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                ส่งข้อความ
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
